import { render, staticRenderFns } from "./AddLabelDialog.vue?vue&type=template&id=00474d4a&"
import script from "./AddLabelDialog.vue?vue&type=script&lang=js&"
export * from "./AddLabelDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddLabelDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports